import { PLACEHOLDER } from 'components/column-renderers'
import { CareArticleType, EOp, FilterModel, FilterModelText, SharedContentReport } from 'types'

export const getSharingContentName = (item: SharedContentReport) => {
  if (item.lessonId) {
    return item.lessonName
  }

  if (item.careArticleId) {
    return item.careArticleName
  }

  if (item.learnArticleId) {
    return item.learnArticleName
  }

  if (item.noteId) {
    return item.noteSubject
  }

  return PLACEHOLDER
}

export const getSharingContentType = (item: SharedContentReport) => {
  if (item.contentType === 'lesson') {
    return 'Lesson'
  }

  if (item.contentType === 'learnArticle') {
    return 'Learn Article'
  }

  if (item.contentType === 'note') {
    return 'Note'
  }

  if (item.contentType === 'careArticle') {
    if (item.careArticleType === CareArticleType.Care) {
      return 'Guide Post'
    }
    if (item.careArticleType === CareArticleType.Task) {
      return 'Action Post'
    }
  }

  return item.contentType
}

export const applyContentNameFilter = (filter: FilterModel): FilterModel => {
  const filterValue: FilterModelText = {
    type: 'text',
    op: EOp.contains,
    value: (filter.contentName as FilterModelText).value,
  }

  return {
    ...filter,
    or: [
      {
        lessonName: filterValue,
      },
      {
        learnArticleName: filterValue,
      },
      {
        careArticleName: filterValue,
      },
      {
        noteSubject: filterValue,
      },
    ],
  }
}
